import { FeaturesManagement } from '../../featuresControl';

const loggerIsEnabled = FeaturesManagement.tools.logger;

export const normalizeQueryParams = (query = ''): string => {
  if (!query) {
    return '';
  }

  if (query.startsWith('?')) {
    return query;
  }

  return query.replace(/^&/, '?');
};

export const logger = {
  warning: (...arg: any[]): void => {
    if (loggerIsEnabled) {
      console.warn(...arg);
    }
  },
  info: (...arg: any[]): void => {
    if (loggerIsEnabled) {
      console.info(...arg);
    }
  },
  error: (...arg: any[]): void => {
    if (loggerIsEnabled) {
      console.error(...arg);
    }
  },
  withErrorLog: (fn: (e: Error) => void) => (error: Error): void => {
    console.error(error);
    return fn(error);
  },
};
